module.exports = __webpack_public_path__ + "img/quizgiri-logo.3f1319a3.png";